<template>
	<div
		class="absolute bottom-0 left-0 right-0 top-0 group-hover:bg-[rgba(0,0,0,0.08)] group-active:bg-[rgba(0,0,0,0.14)] dark:group-hover:bg-[rgba(255,255,255,0.1)] dark:group-active:bg-[rgba(255,255,255,0.14)]"
	/>
</template>
